<div id='kendoDialog' kendoDialogContainer></div>
<div class="eip-layout-container">
    <div class="eip-layout-header">
        <app-header (esSelectedProjectChanged)="selectedProjectChanged($event)"></app-header>
    </div>
    <div class="eip-layout-content" cdk-scrollable>
        <edms-common-header #edmsprojectheader [showProjectList]="showProjectList" [showDateDetails]="showDateDetails"
            [pageTitle]="pageTitle">
        </edms-common-header>
        <app-loader></app-loader>
        <router-outlet (activate)='handleRoute()'></router-outlet>
    </div>
    <div class="eip-layout-footer">
        <app-footer></app-footer>
    </div>
</div>